import carIcon from '../../../images/map-icons/carA.png';
import carIcon2X from '../../../images/map-icons/carA@2x.png';
import carIcon3X from '../../../images/map-icons/carA@3x.png';
import carSelectedIcon from '../../../images/map-icons/carASelected.png';
import carSelectedIcon2X from '../../../images/map-icons/carASelected@2x.png';
import carSelectedIcon3X from '../../../images/map-icons/carASelected@3x.png';
import arrowSelectedIcon from '../../../images/map-icons/icon2_selected.png';
import arrowSelectedIcon2X from '../../../images/map-icons/icon2_selected@2x.png';
import arrowSelectedIcon3X from '../../../images/map-icons/icon2_selected@3x.png';
import arrowIcon from '../../../images/map-icons/icon2_unselected.png';
import arrowIcon2X from '../../../images/map-icons/icon2_unselected@2x.png';
import arrowIcon3X from '../../../images/map-icons/icon2_unselected@3x.png';
import motorcycleIcon from '../../../images/map-icons/motorcycle.svg';
import motorcycleSelectedIcon from '../../../images/map-icons/motorcycle_selected.svg';
import petIcon from '../../../images/map-icons/pet.svg';
import petSelectedIcon from '../../../images/map-icons/pet_selected.svg';
import truckIcon from '../../../images/map-icons/truck.svg';
import truckSelectedIcon from '../../../images/map-icons/truck_selected.svg';

const MAP_MARKER_ICON_UPDATED_EVENT = 'shieldgps:map-marker-icon-updated';

/**
 * Builds selected and unselected responsive-image definitions for a marker icon.
 */
const imageVariants = (
  unselected,
  unselected2X,
  unselected3X,
  selected,
  selected2X,
  selected3X,
) => ({
  selected: {
    src: selected,
    srcset: `${selected}, ${selected2X} 2x, ${selected3X} 3x`,
  },
  unselected: {
    src: unselected,
    srcset: `${unselected}, ${unselected2X} 2x, ${unselected3X} 3x`,
  },
});

const MAP_MARKER_ICONS = [
  {
    id: 'arrow',
    label: 'Direction arrow',
    rotatesWithHeading: true,
    images: imageVariants(
      arrowIcon,
      arrowIcon2X,
      arrowIcon3X,
      arrowSelectedIcon,
      arrowSelectedIcon2X,
      arrowSelectedIcon3X,
    ),
  },
  {
    id: 'car',
    label: 'Car',
    rotatesWithHeading: true,
    images: imageVariants(
      carIcon,
      carIcon2X,
      carIcon3X,
      carSelectedIcon,
      carSelectedIcon2X,
      carSelectedIcon3X,
    ),
  },
  {
    id: 'pet',
    label: 'Pet',
    rotatesWithHeading: false,
    images: {
      unselected: { src: petIcon },
      selected: { src: petSelectedIcon },
    },
  },
  {
    id: 'truck',
    label: 'Truck',
    rotatesWithHeading: true,
    images: {
      unselected: { src: truckIcon },
      selected: { src: truckSelectedIcon },
    },
  },
  {
    id: 'motorcycle',
    label: 'Motorcycle',
    rotatesWithHeading: true,
    images: {
      unselected: { src: motorcycleIcon },
      selected: { src: motorcycleSelectedIcon },
    },
  },
];

const ICON_MAP = MAP_MARKER_ICONS.reduce((icons, icon) => {
  icons[icon.id] = icon;
  return icons;
}, {});

/**
 * Resolves marker metadata, falling back to the direction arrow for unknown keys.
 */
const getMarkerIcon = type => ICON_MAP[type] || ICON_MAP.arrow;

/**
 * Returns the legacy hardware-based marker default for a device model.
 */
const defaultMapMarkerIconForModel = model => model === 'ATA' ? 'arrow' : 'car';

/**
 * Creates the image element used inside a live or location-history map marker.
 */
const createMarkerIconElement = (type, selected = false, documentObject = document) => {
  const icon = getMarkerIcon(type);
  const image = selected ? icon.images.selected : icon.images.unselected;
  const imageElement = documentObject.createElement('img');
  imageElement.setAttribute('alt', '');
  imageElement.setAttribute('aria-hidden', 'true');
  imageElement.setAttribute('draggable', 'false');
  imageElement.setAttribute('src', image.src);
  if (image.srcset) imageElement.setAttribute('srcset', image.srcset);
  return imageElement;
};

export {
  MAP_MARKER_ICON_UPDATED_EVENT,
  MAP_MARKER_ICONS,
  createMarkerIconElement,
  defaultMapMarkerIconForModel,
  getMarkerIcon,
};
